<template>
    <div class="page-container">
         <div v-if="dataLoading" :key="1" class="loading-overlay">
            <loader></loader>
        </div>
    </div>
</template>
<script>
    import Loader from '../common/loader.vue';
    import Mixins from'../../mixins/mixins.js';
    import {mapGetters} from 'vuex';
    import api from "../../store/utils/api.js";
    import $ from 'webpack-zepto';
    import gql from 'graphql-tag';
    import {_} from "vue-underscore";

    export default {
        data() {
            return {
                dataLoading: true,
            }
        },
        components: {Loader},
        mixins: [Mixins],
        methods: {
            async getCheckout () {
                let uri = api.getCustomerTokenUri();
                let customerToken = null;

                await api.get(api.getCustomerTokenUri())
                    .then((res) => {
                        customerToken = res.access_token;
                    })
                    .catch(error => {
                        this.$helpers.trackEvent("checkout_token_error", {});
                        throw error;
                    });

                var cartOutfits = this.cartOutfits;

                let products = [];
                _.each(cartOutfits, outfit => {
                    _.each(outfit, cartProduct => {
                        if(typeof cartProduct.variant_shopify_id !== 'undefined' && cartProduct.variant_shopify_id) {
                            products.push({
                                variantId: btoa("gid://shopify/ProductVariant/" + cartProduct.variant_shopify_id),
                                quantity: parseInt(cartProduct.cart_product_quantity),
                                customAttributes: cartProduct.custom_attributes
                            });
                        }
                    });
                });

                var checkoutMutation = await this.$apollo.mutate({
                    mutation: gql`
                        mutation ($input: CheckoutCreateInput!) {
                            checkoutCreate(input: $input) {
                                checkout {
                                    id
                                    webUrl
                                }
                            }
                        }
                    `,
                    variables: {
                        input: {
                            lineItems: products
                        }
                    }
                });

                const checkoutId = checkoutMutation.data.checkoutCreate.checkout.id

                var associateCheckoutMutation = await this.$apollo.mutate({
                    mutation: gql`
                        mutation ($checkoutId: ID!, $customerAccessToken: String!) {
                            checkoutCustomerAssociateV2(checkoutId: $checkoutId, customerAccessToken: $customerAccessToken) {
                                checkout {
                                    webUrl
                                }
                            }
                        }
                    `,
                    variables: {
                        checkoutId,
                        customerAccessToken: customerToken,
                    }
                });

                this.$helpers.trackEvent("checkout", {});
                const checkoutUrl = associateCheckoutMutation.data.checkoutCustomerAssociateV2.checkout.webUrl;
                const iABRef = cordova.InAppBrowser.open(checkoutUrl, '_blank', "location=no,toolbar=no,clearcache=yes,clearsessioncache=yes", "X-Shopify-Customer-Access-Token="+customerToken);

                iABRef.addEventListener('message', (event) => {
                    const { data } = event;
                    if(data && data.message) {
                        switch(data.message) {
                            case 'close_checkout_completed':
                                this.$helpers.trackEvent("checkout_success", {});
                                
                                this.$store.dispatch('cart/archiveActiveCart')
                                    .then((response) => {
                                    }).catch(response => {
                                    });

                                setTimeout(() => {
                                    this.$router.push('/')
                                    iABRef.close();
                                });
                                break;
                            case 'close_inapp':
                                this.$router.push('/');
                                iABRef.close();
                                break;
                        }
                    }
                });
            },
        },
        computed: {
            ...mapGetters({
                cartOutfits: 'cart/getCartOutfits'
            })
        },
        mounted() {
            this.getCheckout();
        } 
    }
</script>